<template>
  <div
    :class="['items-center cursor-pointer hover:text-green-400', { 'text-green-400': params.function_type === 'complete_action' && params.data.action_completed_date }]"
  >
    <font-awesome-icon
      :icon="font_awesome_icon"
      class="cursor-pointer w-4 h-4 "
      @click="complete_function"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {},
  data() {
    return {
    };
  },
  computed: {
    font_awesome_icon(){
      if(this.params.function_type==='delete' || this.params.function_type==='delete_v2'){
        return ['fas','trash-can']
      }
      else if(this.params.function_type==='complete_action'){
        return ['far','circle-check']
      }
      else if(this.params.function_type==='download_report_pdf'){
        if(this.params.data.status === 'completed') {
          return ['fas', 'file-arrow-down']
        }
        else if(this.params.data.status === 'failed'){
          return ['fas','circle-exclamation']
        }
        else{
          return ['fas','hourglass-start']
        }
      }
      else {
        return ['fas','circle-plus']
      }
    }
  },
  methods: {
    complete_function(){
      if(this.params.function_type==='delete'){
        this.params.openDeleteConfirmationModal?.(this.params.data.object_id)
      }
      else if(this.params.function_type==='delete_v2'){
        this.params.openDeleteConfirmationModal?.(this.params.data)
      }
      else if(this.params.function_type==='complete_action'){
        this.params.openCompleteActionConfirmationModal?.(this.params.data.object_id,this.params.data.action_completed_date)
      }
      else if(this.params.function_type==='download_report_pdf'){
        if (this.params.data.status === 'completed'){
          this.params.downloadPDF?.(this.params)
        }
      }
      else if(this.params.function_type==='refresh_opportunity'){
        this.params.openRefreshOpportunityModal?.(this.params.data.opportunity_id)
      }
    }
  },
  mounted() {},
};
</script>

<style scoped>
/* Add any necessary styles here */
</style>
